import { token } from '../config';

export const postData = async (url = '', data = {}, accessToken = token) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { 'access-token': accessToken }),
    },
    body: JSON.stringify(data),
  });

  if (response.status !== 200) {
    throw new Error(response.status);
  }

  const responseData = await response.json();

  if (responseData && responseData.code === 1) {
    return responseData.data;
  } else {
    throw new Error(responseData.code);
  }
};

export const getData = async (url = '') => {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'access-token': token }),
    },
  });

  if (response.status !== 200) {
    throw new Error(response.status);
  }

  const responseData = await response.json();

  if (responseData && responseData.code === 1) {
    return responseData.data;
  } else {
    throw new Error(responseData.code);
  }
};

export const getExtData = async (url = '') => {
  try {
    const response = await fetch(url, {
      method: 'GET',
    });

    if (response.status !== 200) {
      throw new Error();
    }

    return response.json();
  } catch (error) {
    if (error && error.message === 'Failed to fetch') {
      throw new Error('510');
    }
    throw new Error(error);
  }
};
